// doctor-frontend/src/pages/owner/SubjectsHome.jsx
import React from 'react';
import { Box, Card, CardActionArea, CardContent, Chip, Divider, Grid, Typography } from '@mui/material';
import OwnerTopNav from '../../components/owner/OwnerTopNav';
import OwnerBrandFooter from '../../components/owner/OwnerBrandFooter';
import { SUBJECT_GROUPS } from '../../constants/subjects';

export default function SubjectsHome() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
      <OwnerTopNav active="subjects" />
      <Box p={3}>
        <Typography variant="h6" sx={{ mb: 1 }}>Academic & Training Areas</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Configure subject and training-area access across institutional deployments.
        </Typography>

        {SUBJECT_GROUPS.map((group) => (
          <Box key={group.key} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>{group.title}</Typography>
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={2}>
              {group.subjects.map((s) => (
                <Grid key={s.slug} item xs={12} sm={6} md={4} lg={3}>
                  <Card variant="outlined" sx={{ height: '100%', bgcolor: 'background.paper' }}>
                    {/* Keep navigation to subject detail within owner portal */}
                    <CardActionArea href={`/owner/subjects/${encodeURIComponent(s.slug)}`}>
                      <CardContent>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>{s.name}</Typography>
                        <Grid container spacing={1}>
                          <Grid item><Chip size="small" label="UG — Coming soon" /></Grid>
                          <Grid item><Chip size="small" label="PG — Coming soon" /></Grid>
                          <Grid item><Chip size="small" label="Internship — See institutions" /></Grid>
                        </Grid>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
        <OwnerBrandFooter />
      </Box>
    </Box>
  );
}
